import { useCurrentUserId } from "@/lib/hooks/useCurrentUserId";

import { useUserPermissions } from "../api/queries/useUserPermissions";

export function useCanGrantLcsw({ enabled = true }: { enabled?: boolean } = {}) {
  const userId = useCurrentUserId();
  const { data: canGrantLcsw, isLoading } = useUserPermissions({
    enabled,
    select: (permissions) => permissions.lcsw?.can_grant_lcsw ?? false,
    userId,
  });

  return { canGrantLcsw: canGrantLcsw ?? false, isLoading };
}
